import { createPortal } from 'react-dom';

import { Button } from '../buttons';
import { Container, Content, ContentInner, Overlay, Title, Buttons } from './dialog.styled';
import { useDialog } from './hooks/use-dialog';
// let lastZIndex = 999;

export const Dialog = (props) => {
  const { title, children, buttons, align = '', size = 'lg', w, closeOnOverlayClick = false, close, ...rest } = props;

  const pad = size === 'sm' ? 15 : 20;

  const doClose = () => {
    if (closeOnOverlayClick && props.close) {
      close();
    }
  };

  /**
   * get buttons el
   * @returns
   */
  const getButtonsEl = () => {
    if (!buttons) {
      return null;
    }
    return buttons.map((el, idx) => {
      const { working, title, img, ...elrest } = el;
      if (working) {
        elrest.className = 'loading';
      }
      return (
        <Button key={idx} {...elrest}>
          {img && <img width="10" src={img} alt="" />}
          {title}
        </Button>
      );
    });
  };

  // buttons
  const buttonsEl = getButtonsEl();

  return createPortal(
    <Container {...rest}>
      <Overlay onClick={doClose} />
      <Content $w={w}>
        {title && <Title $pad={pad}>{title}</Title>}
        <ContentInner $pad={pad}>{children}</ContentInner>
        {buttons && (
          <Buttons $align={align} $pad={pad}>
            {buttonsEl}
          </Buttons>
        )}
      </Content>
    </Container>,
    document.body
  );
};

export { useDialog };
